module.exports = __webpack_public_path__ + "img/7_132.bae8ddbc.png";